import React from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ImageGallery from "react-image-gallery";

import gallery from "./Data";
import "react-image-gallery/styles/css/image-gallery.css";
import { ClickActionEvent } from "../../util/analytics";

const sxHeroContent = { py: 8 };
const sxCardGrid = { pt: 8, pb: 8 };

export default function Gallery() {
  // selectedItem and hover handlers are not used in this component; removed to satisfy lint

  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#050a30" }}>
        <Box sx={{ ...sxHeroContent, backgroundColor: "#050a30" }}>
          <Container maxWidth="md">
            <Typography
              component="h1"
              variant="h3"
              align="center"
              style={{ color: "#7ec8e3" }}
              gutterBottom
            >
              My moments 🖼️
            </Typography>
            <Typography
              variant="h6"
              align="center"
              style={{ color: "#7ec8e3" }}
              paragraph
            >
              These are few well spent, memorable moments I have lived...
            </Typography>
          </Container>
        </Box>
        <Container sx={sxCardGrid} maxWidth="md">
          <ImageGallery
            onSlide={(currentIndex) => {
              ClickActionEvent(
                "Gallery " + gallery[currentIndex]?.description,
                "gallery section",
                "gallery slide changed"
              );
            }}
            items={gallery}
            showIndex={false}
            showBullets={true}
            autoPlay={false}
            slideInterval={3000}
            slideDuration={450}
            showFullscreenButton={true}
            lazyLoad={true}
            showNav={true}
            showThumbnails={false}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
